import { ReveiwListConfigValue, SummaryCardServiceProps } from '@common/review';
import { ReviewListConfigProvider } from '@domains/review-list-common';
import { SummaryCardContainer } from '@domains/review-list-feature';

export function ReviewSummaryCardScreen(props: ReveiwListConfigValue & SummaryCardServiceProps) {
  return (
    <ReviewListConfigProvider
      value={{
        isZigzagApp: props.isZigzagApp,
        catalog_product_id: props.catalog_product_id,
        path: props.path,
        replaceReviewTab: props.replaceReviewTab,
      }}
    >
      <SummaryCardContainer
        ux_review_list={props.ux_review_list}
        related_product_review_summary={props.related_product_review_summary}
      />
    </ReviewListConfigProvider>
  );
}
